import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="py-14 px-4 bg-navy-50 border-t border-navy-100" data-id="element-8">
      <div className="max-w-3xl mx-auto" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-16 rounded-3xl shadow-sm border border-navy-100" data-id="element-10">
          <div className="flex flex-col md:flex-row gap-10 items-center md:items-start" data-id="element-11">
            <div className="shrink-0" data-id="element-12">
              <div className="relative" data-id="element-13">
                <div className="absolute -inset-1 rounded-2xl bg-gradient-to-br from-gold-400 to-gold-600 opacity-40 blur-sm" data-id="element-14" />
                <img src="https://cdn.magicpatterns.com/uploads/2338cQPL5gKfQpSz2aWpwK/WhatsApp_Image_2026-05-25_at_21.01.44.jpg" alt="Paul Ocampo" className="relative w-40 h-40 md:w-48 md:h-48 object-cover rounded-2xl shadow-md ring-1 ring-navy-100 grayscale-[20%]" data-id="element-15" />
              </div>
            </div>

            <div className="text-center md:text-left" data-id="element-16">
              <h2 className="font-serif text-3xl font-bold text-navy-900 mb-2" data-id="element-17">
                Paul Ocampo
              </h2>
              <p className="text-gold-600 text-xs font-bold tracking-[0.2em] uppercase mb-8" data-id="element-18">
                Fundador de Inercia Cero
              </p>

              <div className="space-y-5 text-navy-700 leading-relaxed" data-id="element-19">
                <p data-id="element-20">
                  Este trabajo nace de experiencia real: construcción, pérdida,
                  desorden, reconstrucción y dirección.
                </p>
                <p data-id="element-21">
                  No desde teoría vacía, sino desde procesos vividos con Dios,
                  con el dinero y con la identidad.
                </p>
                <p className="font-medium text-navy-900" data-id="element-22">
                  Hoy acompaño a personas que necesitan dejar de operar desde la
                  fractura y empezar a construir desde orden, conciencia y
                  propósito.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}